import { useEffect, useState } from "react";
import { Search, FileText, Package, Users, IndianRupee } from "lucide-react";
import { api } from "../lib/api";
import { useCompany } from "../context/CompanyContext";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const ICONS = { party: Users, item: Package, invoice: FileText, payment: IndianRupee };

export function GlobalSearch() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const { activeId } = useCompany();
  const nav = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") { e.preventDefault(); setOpen(true); }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  useEffect(() => {
    if (q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data.items || [])).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q, activeId]);

  return (
    <>
      <button data-testid="global-search-trigger" onClick={() => setOpen(true)}
        className="hidden sm:flex h-9 items-center gap-2 rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 text-sm text-slate-400 hover:border-slate-300 dark:hover:border-slate-600 transition-colors w-52">
        <Search className="h-3.5 w-3.5" /> Search...
        <kbd className="ml-auto rounded border border-slate-200 dark:border-slate-700 px-1 text-[10px] font-mono">⌘K</kbd>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent aria-describedby={undefined} className="top-[20%] max-w-lg p-0 gap-0 bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700">
          <div className="flex items-center gap-2 border-b border-slate-100 dark:border-slate-800 px-4">
            <Search className="h-4 w-4 text-slate-400" />
            <input data-testid="global-search-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="Search parties, items, invoices, payments..."
              className="h-12 w-full bg-transparent text-sm outline-none placeholder:text-slate-400" />
          </div>
          <div className="max-h-72 overflow-y-auto p-2" data-testid="global-search-results">
            {q.length >= 2 && results.length === 0 && (
              <p className="py-8 text-center text-sm text-slate-400">No matches in this company</p>)}
            {results.map((r) => {
              const Icon = ICONS[r.type] || FileText;
              return (
                <button key={r.type + r.id} data-testid={`search-result-${r.type}`}
                  onClick={() => { setOpen(false); setQ(""); nav(r.link); }}
                  className="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-left hover:bg-slate-100 dark:hover:bg-slate-800">
                  <Icon className="h-4 w-4 text-slate-400" />
                  <span className="flex-1">
                    <span className="block text-sm font-medium">{r.title}</span>
                    <span className="block text-xs text-slate-500">{r.sub}</span>
                  </span>
                  <span className="text-[10px] uppercase tracking-wider text-slate-400">{r.type}</span>
                </button>
              );
            })}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
